import { client } from '@/http';

export default {
  async hasIncome() {
    const response = await client.get('/api/flat-transactions/has-income');
    return response.data.hasIncomeTransactions;
  },
};
